import afipAvatar from 'assets/images/banks/afip.svg'
import paribasAvatar from 'assets/images/banks/paribas.svg'
import bancorAvatar from 'assets/images/banks/bancor.svg'
import bbvaAvatar from 'assets/images/banks/bbva.svg'
import bcraAvatar from 'assets/images/banks/bcra.svg'
import bibankAvatar from 'assets/images/banks/bibank.svg'
import bicaAvatar from 'assets/images/banks/bica.svg'
import bindAvatar from 'assets/images/banks/bind.svg'
import brubankAvatar from 'assets/images/banks/brubank.svg'
import chacoAvatar from 'assets/images/banks/chaco.svg'
import chinaAvatar from 'assets/images/banks/china.svg'
import chubutAvatar from 'assets/images/banks/chubut.svg'
import citiAvatar from 'assets/images/banks/citi.svg'
import ciudadAvatar from 'assets/images/banks/ciudad.svg'
import cmfCorporativoAvatar from 'assets/images/banks/cmf_corporativo.svg'
import coinagAvatar from 'assets/images/banks/coinag.svg'
import columbiaAvatar from 'assets/images/banks/columbia.svg'
import comafiAvatar from 'assets/images/banks/comafi.svg'
import comercioAvatar from 'assets/images/banks/comercio.svg'
import corrientesAvatar from 'assets/images/banks/corrientes.svg'
import credicoopAvatar from 'assets/images/banks/credicoop.svg'
import dinoAvatar from 'assets/images/banks/dino.svg'
import efectivoSiAvatar from 'assets/images/banks/efectivo_si.svg'
import entreRiosAvatar from 'assets/images/banks/entre_rios.svg'
import formosaAvatar from 'assets/images/banks/formosa.svg'
import galiciaAvatar from 'assets/images/banks/galicia.svg'
import hipotecarioAvatar from 'assets/images/banks/hipotecario.svg'
import hsbcAvatar from 'assets/images/banks/hsbc.svg'
import icbcAvatar from 'assets/images/banks/icbc.svg'
import itauAvatar from 'assets/images/banks/itau.svg'
import jpMorganAvatar from 'assets/images/banks/jp_morgan.svg'
import julioAvatar from 'assets/images/banks/julio.svg'
import macroAvatar from 'assets/images/banks/macro.svg'
import marivaAvatar from 'assets/images/banks/mariva.svg'
import masVentasAvatar from 'assets/images/banks/mas_ventas.svg'
import meridianAvatar from 'assets/images/banks/meridian.svg'
import municipalAvatar from 'assets/images/banks/municipal.svg'
import nacionAvatar from 'assets/images/banks/nacion.svg'
import neuquenAvatar from 'assets/images/banks/neuquen.svg'
import pampaAvatar from 'assets/images/banks/pampa.svg'
import patagoniaAvatar from 'assets/images/banks/patagonia.svg'
import pianoAvatar from 'assets/images/banks/piano.svg'
import positivoAvatar from 'assets/images/banks/positivo.svg'
import provinciaAvatar from 'assets/images/banks/provincia.svg'
import rebaFinancieraAvatar from 'assets/images/banks/reba_financiera.svg'
import riojaAvatar from 'assets/images/banks/rioja.svg'
import roelaAvatar from 'assets/images/banks/roela.svg'
import saenzAvatar from 'assets/images/banks/saenz.svg'
import sanJuanAvatar from 'assets/images/banks/san_juan.svg'
import santaCruzAvatar from 'assets/images/banks/santa_cruz.svg'
import santaFeAvatar from 'assets/images/banks/santa_fe.svg'
import santanderAvatar from 'assets/images/banks/santander.svg'
import santiagoEsteroAvatar from 'assets/images/banks/santiago_del_estero.svg'
import solAvatar from 'assets/images/banks/sol.svg'
import supervielleAvatar from 'assets/images/banks/supervielle.svg'
import tierraFuegoAvatar from 'assets/images/banks/tierra_del_fuego.svg'
import transatlanticaAvatar from 'assets/images/banks/transatlantica.svg'
import valoresAvatar from 'assets/images/banks/valores.svg'
import voiiAvatar from 'assets/images/banks/voii.svg'
import galiciaMas from 'assets/images/banks/GaliciaMas.svg'

const getAvatar = (bankName: string): string => {
  // TODO: map banks by id from BD
  const avatars = {
    afipAvatar,
    'BNP Paribas': paribasAvatar,
    'Bco. Cordoba': bancorAvatar,
    'BBVA': bbvaAvatar,
    'BCRA': bcraAvatar,
    'Interfinanzas': bibankAvatar,
    'Banco Bica S.A.': bicaAvatar,
    'Industrial': bindAvatar,
    'Brubank': brubankAvatar,
    'Banco del Chaco': chacoAvatar,
    'Bank of China': chinaAvatar,
    'Bco. del Chubut': chubutAvatar,
    'Citibank': citiAvatar,
    'Banco Ciudad': ciudadAvatar,
    'CMF': cmfCorporativoAvatar,
    'Banco Coinag': coinagAvatar,
    'Columbia': columbiaAvatar,
    'Comafi': comafiAvatar,
    'BANCO COMERCIO': comercioAvatar,
    'Corrientes': corrientesAvatar,
    'Credicoop': credicoopAvatar,
    'BANCO DINO': dinoAvatar,
    efectivoSiAvatar,
    'NBersa': entreRiosAvatar,
    'Banco Formosa': formosaAvatar,
    'Galicia': galiciaAvatar,
    'Bco Hipotecario': hipotecarioAvatar,
    'HSBC':hsbcAvatar,
    'ICBC': icbcAvatar,
    'ITAU': itauAvatar,
    'JPMorgan': jpMorganAvatar,
    'Banco Julio': julioAvatar,
    'Macro S.A.': macroAvatar,
    'Mariva': marivaAvatar,
    'BMV': masVentasAvatar,
    'Meridian': meridianAvatar,
    'BMR': municipalAvatar,
    'B.N.A.': nacionAvatar,
    'BPN S.A.': neuquenAvatar,
    'Banco Pampa': pampaAvatar,
    'Patagonia': patagoniaAvatar,
    'Banco Piano': pianoAvatar,
    'BST': positivoAvatar,
    'Bco Pcia.Bs.As.': provinciaAvatar,
    'Reba Financiera': rebaFinancieraAvatar,
    'NBLR': riojaAvatar,
    'BANCO ROELA': roelaAvatar,
    'BCO. SAENZ S.A.': saenzAvatar,
    'Banco San Juan': sanJuanAvatar,
    'BCO SANTA CRUZ': santaCruzAvatar,
    'Bco. Santa Fe': santaFeAvatar,
    'Santander Rio': santanderAvatar,
    'BSE': santiagoEsteroAvatar,
    'Banco del Sol': solAvatar,
    'Supervielle': supervielleAvatar,
    'BTF': tierraFuegoAvatar,
    transatlanticaAvatar,
    'BANCO VALORES': valoresAvatar,
    'VOII': voiiAvatar,
    'Galicia Más': galiciaMas
  }

  return avatars[bankName] || ''
}

export default getAvatar
